var mapFromId = [
    [false, false, false],
    [true, false, false],
    [false, false, true],
    [false, true, false],
    [true, false, true],
    [true, true, true],
    [true, true, false],
    [false, true, true]
];

export default mapFromId
